import lazyLoadWithRetry from 'utils/lazyLoadWithRetry';

export const SalaryExplainerWrapper = lazyLoadWithRetry(
  () => import('components/AiSalaryExplainer/SalaryExplainer'),
);
